export const enum authConstants  {
  userLoginRequest = "USER_LOGIN_REQUEST",
  userLoginSuccess = "USER_LOGIN_SUCCESS",
  userLoginFailure = "USER_LOGIN_FAILURE",

  // OTP flow (phone-based)
  otpLoginRequest = "OTP_LOGIN_REQUEST", // send OTP
  otpLoginSuccess = "OTP_LOGIN_SUCCESS",
  otpLoginFailure = "OTP_LOGIN_FAILURE",

  otpVerifyRequest = "OTP_VERIFY_REQUEST", // send OTP
  otpVerifySuccess = "OTP_VERIFY_SUCCESS",
  otpVerifyFailure = "OTP_VERIFY_FAILURE",

  resendOtpRequest = "RESEND_OTP_REQUEST",
  resendOtpSuccess = "RESEND_OTP_SUCCESS",
  resendOtpFailure = "RESEND_OTP_FAILURE",

  renewTokenRequest = "RENEW_TOKEN_REQUEST",
  renewTokenSuccess = "RENEW_TOKEN_SUCCESS",
  renewTokenFailure = " RENEW_TOKEN_FAILURE",

  verifyTokenRequest = "VERIFY_TOKEN_REQUEST",
  verifyTokenSuccess = "VERIFY_TOKEN_SUCCESS",
  verifyTokenFailure = "VERIFY_TOKEN_FAILURE",

  acceptInvitationRequest = "ACCEPT_INVITATION_REQUEST",
  acceptInvitationSuccess = "ACCEPT_INVITATION_SUCCESS",
  acceptInvitationFailure = "ACCEPT_INVITATION_FAILURE",

  // Tenant Registration
  registerTenantRequest = "REGISTER_TENANT_REQUEST",
  registerTenantSuccess = "REGISTER_TENANT_SUCCESS",
  registerTenantFailure = "REGISTER_TENANT_FAILURE",

  verifyRegistrationRequest = "VERIFY_REGISTRATION_REQUEST",
  verifyRegistrationSuccess = "VERIFY_REGISTRATION_SUCCESS",
  verifyRegistrationFailure = "VERIFY_REGISTRATION_FAILURE",

  checkTenantExistsRequest = "CHECK_TENANT_EXISTS_REQUEST",
  checkTenantExistsSuccess = "CHECK_TENANT_EXISTS_SUCCESS",
  checkTenantExistsFailure = "CHECK_TENANT_EXISTS_FAILURE",

  // Device Limit & Revocation
  revokeDeviceSessionRequest = "REVOKE_DEVICE_SESSION_REQUEST",
  revokeDeviceSessionSuccess = "REVOKE_DEVICE_SESSION_SUCCESS",
  revokeDeviceSessionFailure = "REVOKE_DEVICE_SESSION_FAILURE",
  clearDeviceLimit = "CLEAR_DEVICE_LIMIT",

  // Global auth/logout
  userLogout = "USER_LOGOUT",

  logoutRequest = "LOGOUT_REQUEST",
  logoutSuccess = "LOGOUT_SUCCESS",
  logoutFailure = "LOGOUT_FAILURE",
};